module.exports = __webpack_public_path__ + "static/media/wechat.eebe66f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Booking/svg/wechat.png
// module id = 1552
// module chunks = 0